/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PENDING` - Pending
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 */
export enum StatusByProviderEnum {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}
